import { gql } from '@apollo/client';

export const EXPORT_ENTITY = gql`
  mutation exportEntity($id: Int!, $type: String!) {
    exportEntity(id: $id, type: $type)
  }
`;

export const IMPORT_ENTITY = gql`
  mutation importEntity($serializedEntity: String!) {
    importEntity(serializedEntity: $serializedEntity)
  }
`;
